var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"produpneu-app"}},[_c(_vm.currentLayout,{key:_vm.currentLayoutName,tag:"component"},[_c('router-view')],1),_vm._v(" "),_c('GlobalToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }